import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeRepairReportDetail } from './normalizeRepairReportDetail';
import { serializeRepairReportRefuse } from './serialize';

/**
 * 拒修／作廢：DRAFT → REFUSED。
 * POST `/aftersales/repair-report/{id}/refuse`。
 * body：`refuseReason`＋`updatedAt`（**非** discard）。
 *
 * @param {string} id
 * @param {{ refuseReason?: string, updatedAt?: string, record?: { updatedAt?: string } }} payload
 */
export async function refuseRepairReport(id, payload) {
  const { data: raw } = await request.post(
    `/aftersales/repair-report/${id}/refuse`,
    serializeRepairReportRefuse(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeRepairReportDetail(parsed.data),
  };
}
